module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THER")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OOKS BY")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALCOLM")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AY")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('em', [_vm._v("Wounded and a Prisoner of War")]), _vm._v("     1916")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('em', [_vm._v("A Chain of Error in Scottish History")]), _vm._v("     1927")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('em', [_vm._v("The Blairs Papers (1603–1660)")]), _vm._v("     1929")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('em', [_vm._v("The Jesuits and the Popish Plot")]), _vm._v("     1934")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('em', [_vm._v("Winston Churchill and James II")]), _vm._v("     1934")]), _vm._v(" "), _c('p', {
    staticClass: "fm-para"
  }, [_c('em', [_vm._v("The Enigma of James II")]), _vm._v("     1938")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a119b80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_FM1.vue
// module id = 78
// module chunks = 0